var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-body-reset-password" }, [
    _c("div", { staticClass: "description" }, [
      _vm._v("\n    Reset password by entering the information below.\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field-wrapper" }, [
      _c("div", { staticClass: "text" }, [_vm._v("Current password:")]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.resetPasswordInfo.oldPassword,
              expression: "resetPasswordInfo.oldPassword"
            }
          ],
          staticClass: "input",
          attrs: {
            "data-vv-as": "old password",
            name: "oldPassword",
            type: "password"
          },
          domProps: { value: _vm.resetPasswordInfo.oldPassword },
          on: {
            blur: function($event) {
              _vm.validateInput("oldPassword")
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.resetPasswordInfo,
                "oldPassword",
                $event.target.value
              )
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "errorBackground",
          class: {
            errorBackgroundColor:
              _vm.errors.has("oldPassword") &&
              _vm.validatedFields.includes("oldPassword")
          }
        },
        [
          _vm.validatedFields.includes("oldPassword")
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("oldPassword"),
                      expression: "errors.has('oldPassword')"
                    }
                  ],
                  staticClass: "errorDetail"
                },
                [_vm._v(_vm._s(_vm.errors.first("oldPassword")))]
              )
            : _vm._e()
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field-wrapper" }, [
      _c("div", { staticClass: "text" }, [_vm._v("New Password:")]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.resetPasswordInfo.newPassword,
              expression: "resetPasswordInfo.newPassword"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            }
          ],
          staticClass: "input",
          attrs: {
            "data-vv-as": "new password",
            name: "newPassword",
            type: "password"
          },
          domProps: { value: _vm.resetPasswordInfo.newPassword },
          on: {
            blur: function($event) {
              _vm.validateInput("newPassword")
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.resetPasswordInfo,
                "newPassword",
                $event.target.value
              )
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "errorBackground",
          class: {
            errorBackgroundColor:
              (_vm.errors.has("newPassword") &&
                _vm.validatedFields.includes("newPassword")) ||
              !_vm.isPasswordContainsNumber
          }
        },
        [
          _vm.validatedFields.includes("newPassword")
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.first("newPassword"),
                      expression: "errors.first('newPassword')"
                    }
                  ],
                  staticClass: "errorDetail"
                },
                [_vm._v(_vm._s(_vm.errors.first("newPassword")))]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isPasswordContainsNumber && !_vm.errors.has("newPassword")
            ? _c("span", { staticClass: "errorDetail" }, [
                _vm._v("The New password must contains at least 1 digit")
              ])
            : _vm._e()
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field-wrapper" }, [
      _c("div", { staticClass: "text" }, [_vm._v("Confirm New Password:")]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.resetPasswordInfo.repeatPassword,
              expression: "resetPasswordInfo.repeatPassword"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: {
                required: true,
                confirmed: _vm.resetPasswordInfo.newPassword
              },
              expression:
                "{ required: true, confirmed: resetPasswordInfo.newPassword }"
            }
          ],
          staticClass: "input",
          attrs: {
            type: "password",
            "data-vv-as": "confirm password",
            name: "repeatPassword"
          },
          domProps: { value: _vm.resetPasswordInfo.repeatPassword },
          on: {
            blur: function($event) {
              _vm.validateInput("repeatPassword")
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.resetPasswordInfo,
                "repeatPassword",
                $event.target.value
              )
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "errorBackground",
          class: {
            errorBackgroundColor:
              _vm.errors.has("repeatPassword") &&
              _vm.validatedFields.includes("repeatPassword")
          }
        },
        [
          _vm.validatedFields.includes("repeatPassword")
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("repeatPassword"),
                      expression: "errors.has('repeatPassword')"
                    }
                  ],
                  staticClass: "errorDetail"
                },
                [_vm._v(_vm._s(_vm.errors.first("repeatPassword")))]
              )
            : _vm._e()
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "password-check-list" }, [
      _c("div", { staticClass: "password-at-least" }, [
        _vm._v("Password must have at least:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "indicators-password row" }, [
        _c("div", { staticClass: "indicator-item col-lg-6" }, [
          _c(
            "div",
            {
              staticClass: "icon-wrapper",
              style: _vm.hiddenIconPasswordIndicator
            },
            [
              _vm.passwordCheckList.length
                ? _c("div", { staticClass: "icon-reach" })
                : _c("div", { staticClass: "icon-unreach" })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [_vm._v("8 characters ")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "indicator-item col-lg-6" }, [
          _c(
            "div",
            {
              staticClass: "icon-wrapper",
              style: _vm.hiddenIconPasswordIndicator
            },
            [
              _vm.passwordCheckList.lowerCaseChars
                ? _c("div", { staticClass: "icon-reach" })
                : _c("div", { staticClass: "icon-unreach" })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [
            _vm._v("4 lowercase letters (a-z)")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "indicator-item col-lg-6" }, [
          _c(
            "div",
            {
              staticClass: "icon-wrapper",
              style: _vm.hiddenIconPasswordIndicator
            },
            [
              _vm.passwordCheckList.upperCaseChars
                ? _c("div", { staticClass: "icon-reach" })
                : _c("div", { staticClass: "icon-unreach" })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [
            _vm._v("1 uppercase letter (A-Z)")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "indicator-item col-lg-6" }, [
          _c(
            "div",
            {
              staticClass: "icon-wrapper",
              style: _vm.hiddenIconPasswordIndicator
            },
            [
              _vm.passwordCheckList.numbers
                ? _c("div", { staticClass: "icon-reach" })
                : _c("div", { staticClass: "icon-unreach" })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [_vm._v("2 numbers (0-9)")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "indicator-item col-lg-6" }, [
          _c(
            "div",
            {
              staticClass: "icon-wrapper",
              style: _vm.hiddenIconPasswordIndicator
            },
            [
              _vm.passwordCheckList.specialChars
                ? _c("div", { staticClass: "icon-reach" })
                : _c("div", { staticClass: "icon-unreach" })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [_vm._v("1 special character")])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2268234f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2268234f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ResetPasswordModal.vue
// module id = 1355
// module chunks = 1